module.exports = __webpack_public_path__ + "411b8c38898b72c4b29c3658e635fcc8.svg";